import {
  queryByCusName,
  customerRecevieInfoQueryByCbId,
  queryByClassCodeCRM
} from '@/api/customer/customerManage' // 客户管理接口api
import {
  queryByClassCode,
  updateStateById,
  getQueryAddress
} from '@/api/system/rightsManagement' // 系统设置接口api
import {
  supplierActivityDelete,
  supplierActivityUpdateByState
} from '@/api/supplier/supplierManage' // 供应商接口api
import {
  queryAllProductClassForCascader,
  queryAllBrandForSelect
} from '@/api/product/productManage' // 产品管理接口api
import {
  houseInformation
} from '@/api/storage/storage' // 产品管理接口api
import {
  province
} from '@/assets/js/site' // 省市区

export default {

  install (Vue) {
    // -----------------------------------共用方法-----------------------------------
    Vue.prototype.$copy = function (value) {
      this.$copyText(
       `${value}`
      ).then(res => {
        // 这是element的Message 消息提示组件
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      })
    }

    // 设置表格头部背景色
    Vue.prototype.$tableHeader = function (val) {
      if (val === 0) {
        return 'background-color: #F6F7FA;color: #4E555B;text-align:left;font-weight:500;height:48px;'
      }
    }
    // 模糊查询传参方法
    Vue.prototype.$queryParams = function (val, params) {
      const criteriaVoList = []
      for (const key in val) {
        if (params === 'moreSearch') { // 参考产品管理列表搜索,产品搜索可以有更多条件搜索
          if (val[key] !== '' && val[key] !== undefined && val[key] !== null) { // 判断是否value是否有值
            criteriaVoList.push({
              collection: true,
              column: key,
              value: val[key],
              valueType: '',
              expression: val.expression
            })
          }
        } else if (params === 'noExpression') {
          if (val[key]) { // 判断是否expression是否有值
            criteriaVoList.push({
              collection: true,
              column: key,
              endValue: '',
              value: val[key],
              valueType: '',
              expression: ''
            })
          }
        } else if (params) { // 单个条件搜索
          if (params.endValue) { // 开始和结束日期
            criteriaVoList.push({
              collection: true,
              column: val[key],
              value: params.value,
              endValue: params.endValue,
              valueType: '',
              expression: params.expression
            })
          } else {
            criteriaVoList.push({
              collection: true,
              column: val[key],
              value: params.value,
              valueType: '',
              expression: params.expression
            })
          }
        }
      }
      return criteriaVoList
    }
    // 解析地址
    Vue.prototype.$analysisAddress = (value, label) => {
      const code = value.split('-')
      const provinceName = label.split('-')
      const provinceList = {
        value: code[0],
        label: provinceName[0]
      }
      const cityList = {
        value: code[1],
        label: provinceName[1]
      }
      const districtList = {
        value: code[2],
        label: provinceName[2]
      }
      const params = {
        province: provinceList,
        city: cityList,
        district: districtList
      }
      return params
    }
    // 解析地址
    Vue.prototype.$analysisAddressName = (name) => {
      // const code = id.split('-')
      const provinceName = name.split('-')
      const provinceList = {
        name: provinceName[0]
      }
      const cityList = {
        name: provinceName[1]
      }
      const districtList = {
        name: provinceName[2]
      }
      province.forEach(element => {
        if (element.name === provinceList.name) {
          provinceList.id = element.id
          element.children.forEach(ele => {
            if (ele.name === cityList.name) {
              cityList.id = ele.id
              ele.children.forEach(eles => {
                if (eles.name === districtList.name) {
                  districtList.id = eles.id
                }
              })
            }
          })
        }
      })
      const params = {
        province: provinceList,
        city: cityList,
        district: districtList
      }
      return params
    }

    Vue.prototype.$apeendFormData = (data = {}) => {
      const form = new FormData()
      for (const key in data) {
        form.append(key, data[key])
      }
      return form
    }

    // 处理上传后的文件数据
    Vue.prototype.$upload = function (fileList) {
      const arrList = []
      fileList.forEach(item => {
        item.response.obj.forEach(res => {
          arrList.push(res)
        })
      })
      return arrList
    }
    // -----------------------------------分割线以下是共用接口-----------------------------------
    // 验证客户名称是否重复
    Vue.prototype.$queryByCusName = function (val) {
      queryByCusName(val).then(res => {
        if (res.data.code === 200) {
          this.$message.success('客户名称验证通过')
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    }
    // 根据pid查看对应下属地区
    Vue.prototype.$getQueryAddress = (val) => {
      let provinceList = []
      return new Promise((resolve, reject) => {
        getQueryAddress(val).then(res => {
          if (res.data.code === 200) {
            provinceList = res.data.obj
            resolve(provinceList)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
    // 根据多个分类类型显示属性内容
    Vue.prototype.$queryByClassCode = () => {
      const typeList = ['industry_type', 'from_type', 'paytype_type', 'customer_type', 'implevel_type', 'minimumunit']
      const params = {
        fromTypeList: [],
        industryTypeList: [],
        payTypeList: [],
        customerType: [],
        implevelType: [],
        unitList: []
      }
      return new Promise((resolve, reject) => {
        queryByClassCode(typeList).then(res => {
          if (res.data.code === 200) {
            res.data.obj.forEach(item => {
              if (item.classCode === 'from_type') {
                params.fromTypeList = item.attrContent
              } else if (item.classCode === 'industry_type') {
                params.industryTypeList = item.attrContent
              } else if (item.classCode === 'paytype_type') {
                params.payTypeList = item.attrContent
              } else if (item.classCode === 'customer_type') {
                params.customerType = item.attrContent
              } else if (item.classCode === 'implevel_type') {
                params.implevelType = item.attrContent
              } else if (item.classCode === 'minimumunit') {
                params.unitList = item.attrContent
              }
            })
            resolve(params)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
    // crm
    Vue.prototype.$queryByClassCodeCRM = () => {
      const typeList = ['industry_type', 'from_type', 'paytype_type', 'customer_type', 'implevel_type', 'minimumunit']
      const params = {
        fromTypeList: [],
        industryTypeList: [],
        payTypeList: [],
        customerType: [],
        implevelType: [],
        unitList: []
      }
      return new Promise((resolve, reject) => {
        queryByClassCodeCRM(typeList).then(res => {
          if (res.data.code === 200) {
            res.data.obj.forEach(item => {
              if (item.classCode === 'from_type') {
                params.fromTypeList = item.attrContent
              } else if (item.classCode === 'industry_type') {
                params.industryTypeList = item.attrContent
              } else if (item.classCode === 'paytype_type') {
                params.payTypeList = item.attrContent
              } else if (item.classCode === 'customer_type') {
                params.customerType = item.attrContent
              } else if (item.classCode === 'implevel_type') {
                params.implevelType = item.attrContent
              } else if (item.classCode === 'minimumunit') {
                params.unitList = item.attrContent
              }
            })
            resolve(params)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
    // 分类停用启用
    Vue.prototype.$onOpenOrClose = function (params) {
      return new Promise((resolve, reject) => {
        let boolean = false
        updateStateById(params.id, !params.flag).then(res => {
          if (res.data.code === 200) {
            this.$message.success(params.flag ? '已停用！' : '已启用')
            boolean = true
            resolve(boolean)
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
    // 前端获取品类最后一级id后,根据最后一级id知道到上面两级id拼成数组格式
    Vue.prototype.$idFindParent = function (id, data) {
      const arr = []
      let returnArr = []
      let depth = 0

      function findChild (childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN
          arr[depthN] = childrenData[j].id
          if (childrenData[j].id === id) {
            returnArr = arr.slice(0, depthN + 1)
            break
          } else {
            if (childrenData[j].children) {
              depth++
              findChild(childrenData[j].children, depth)
            }
          }
        }
        return returnArr
      }
      return findChild(data, depth)
    }
    // 根据最后一级的品类id获取品类面包屑
    Vue.prototype.$findCrumbsById = function (pcid, proClassList) {
      const productClassKey = {}
      for (let i = 0, size = proClassList.length; i < size; i++) {
        const item = proClassList[i]
        for (let j = 0, jsize = item.children.length; j < jsize; j++) {
          const itemChildren = item.children[j]
          for (let k = 0, ksize = itemChildren.children.length; k < ksize; k++) {
            const itemChildrenChildren = itemChildren.children[k]
            productClassKey[itemChildrenChildren.id] = item.label + ' > ' + itemChildren.label + ' > ' + itemChildrenChildren.label
          }
        }
      }
      return productClassKey[pcid]
    }
    // 品类共用接口
    Vue.prototype.$queryAllProductClassForCascader = function () {
      return new Promise((resolve, reject) => {
        let arrList = []
        queryAllProductClassForCascader().then(res => {
          if (res.data.code === 200) {
            arrList = this.$ConTree(
              res.data.obj,
              'id',
              'fid',
              'children'
            )
            resolve(arrList)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
    // 品牌共用接口
    Vue.prototype.$queryAllBrandForSelect = function () {
      return new Promise((resolve, reject) => {
        let arrList = []
        queryAllBrandForSelect().then(res => {
          if (res.data.code === 200) {
            arrList = res.data.obj
          }
          resolve(arrList)
        }).catch(err => {
          reject(err)
        })
      })
    }
    // 仓库共用接口
    Vue.prototype.$houseInformation = function () {
      return new Promise((resolve, reject) => {
        let arrList = []
        houseInformation().then(res => {
          if (res.data.code === 200) {
            arrList = res.data.obj
          }
          resolve(arrList)
        }).catch(err => {
          reject(err)
        })
      })
    }
    // 删除活动
    Vue.prototype.$deleteActivity = function (params) {
      return new Promise((resolve, reject) => {
        supplierActivityDelete(params.id).then(res => {
          if (res.data.code === 200) {
            this.$message.success('删除成功!')
            resolve(true)
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
    // 结束活动
    Vue.prototype.$endActivity = function (params) {
      return new Promise((resolve, reject) => {
        supplierActivityUpdateByState(params).then(res => {
          if (res.data.code === 200) {
            this.$message.success('已结束活动!')
            resolve(true)
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
    // 根据客户id查看收货人
    Vue.prototype.$getCustomerRecevie = (id) => {
      return new Promise((resolve, reject) => {
        let list = []
        customerRecevieInfoQueryByCbId(id).then(res => {
          if (res.data.code === 200) {
            list = res.data.obj
            resolve(list)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
